import React, { useState } from 'react';
import Button from 'antd/lib/button';
import Select from 'antd/lib/select';
import { DotChartOutlined } from '@ant-design/icons';
import { Badge, ConfigProvider, Modal } from 'antd/lib';
import { getAntdThemeTokens, runwayColors } from '@/components/styles/globalStyles';
import { GetOrgOverviewMetrics, displayOrgOverviewStatisticLabel } from '@/components/orgOverview/orgOverviewHelpers';
import { useSidebarColors, useSidebarTheme, useThemeMode } from '@/components/styles/themeMode';
import antdTheme from 'antd/lib/theme';

interface OrgOverviewMetricsSelectorProps {
    selectedMetrics: string[];
    setSelectedMetrics: (value: string[]) => void;
}

export const OrgOverviewMetricsSelector = ({
    selectedMetrics,
    setSelectedMetrics,
}: OrgOverviewMetricsSelectorProps) => {
    const sidebarColors = useSidebarColors();
    const sidebarTheme = useSidebarTheme();

    const [filtersVisible, setFiltersVisible] = useState(false);
    const openModal = () => setFiltersVisible(true);
    const closeModal = () => setFiltersVisible(false);

    const { mode } = useThemeMode();
    const isDark = mode === 'dark';

    const options = GetOrgOverviewMetrics()
        .map((metricType) => ({
            label: displayOrgOverviewStatisticLabel(metricType),
            value: metricType,
        }))
        .filter((option) => !!option.label);

    const appliedFiltersCount = selectedMetrics?.length || 0;

    return (
        <Badge
            count={appliedFiltersCount > 0 ? appliedFiltersCount : null}
            style={{
                backgroundColor: runwayColors.primary,
                borderColor: runwayColors.white,
                color: 'white',
                fontSize: 13,
            }}
        >
            <Button
                icon={<DotChartOutlined style={{ color: runwayColors.primary }} />}
                type="default"
                style={{
                    width: 248,
                    border: `1px solid ${sidebarColors.border}`,
                    backgroundColor: sidebarTheme !== 'light' ? 'transparent' : sidebarColors.dropdownBg,
                }}
                onClick={openModal}
            >
                Select metrics...
            </Button>
            <ConfigProvider
                theme={{
                    algorithm: isDark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
                    token: getAntdThemeTokens(isDark ? 'dark' : 'light'),
                }}
            >
                <Modal
                    title="Metrics"
                    open={filtersVisible}
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'stretch',
                    }}
                    onClose={closeModal}
                    onOk={closeModal}
                    onCancel={closeModal}
                    cancelButtonProps={{ style: { display: 'none' } }}
                >
                    <div
                        style={{
                            paddingLeft: 16,
                            paddingRight: 16,
                            paddingBottom: 18,
                            maxHeight: 450,
                            overflowY: 'scroll',
                        }}
                    >
                        <Select
                            mode="multiple"
                            style={{ width: '100%' }}
                            value={selectedMetrics}
                            onChange={(values) => setSelectedMetrics(values)}
                            options={options}
                        />
                    </div>
                </Modal>
            </ConfigProvider>
        </Badge>
    );
};
